namespace GeniuzPOS.PosShift {
    export class PsQueueColumns {
        static columnsKey = 'PosShift.PsQueue';
    }
}
